<template>
  <div
      class="order-status"
      :class="'order-status-' + orderStatus.replaceAll(' ', '-').toLowerCase()">
    {{ orderStatus }}
  </div>
</template>

<script>
export default {
  name: "OrderStatus",
  props: {
    orderStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.order-status {
  margin: 4px;
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  background: #eaeaea;
  width: fit-content;
}

.order-status-pending,
.order-status-waiting-for-updates,
.order-status-in-process {
  background: #f0ecf9 !important;
  color: #4d11f1 !important;
}

.order-status-label-created {
  background: #eff8fc !important;
  color: #1476ad !important;
}

.order-status-paid {
  background: #eff8fc !important;
  color: #178019 !important;
}

.order-status-canceled,
.order-status-cancelled {
  background: #fcefef !important;
  color: #d4231a !important;
}

.order-status-manual-tracking {
  background: #fdefe6 !important;
  color: #f1670d !important;
}
</style>
